import moment from 'moment/moment'
import { Box, Paper, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import styles from './SubscriptionsCredits.module.scss'
import { formatDate } from '../../../../../../../utils/helpers'

type Props = {
  item: {
    name?: string,
    expiresAt: Date,
    downloads?: number,
    used?: number,
  },
  style?: {}
}
export const CardSubscriptions = (props: Props) => {
  const {item, style} = props;
  const { t } = useTranslation()
  return (
    <Paper style={style} className={styles.contentPaper}>
      <div className={styles.bold}>
        <Typography fontWeight={'bold'} fontSize={18}>{`${t('Plan')}: ${item?.name}`}</Typography>
      </div>
      <br/>
      <Box>
        <span className={styles.bold}>{t('Expiration Date')}:</span>{' '}
        {formatDate(item?.expiresAt as any, true)}
      </Box>
      <Box sx={{marginTop: 1}}>
        <span className={styles.bold}>{t('Remaining Downloads')}:</span>{' '}
        {Number(Number(item?.downloads || 0) - Number(item?.used || 0))}({item?.downloads || 0})
      </Box>
    </Paper>
  )
}
export default CardSubscriptions